import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Rules from "./pages/Rules";
import RuleBuilder from "./pages/RuleBuilder";
import Approvals from "./pages/Approvals";
import Activity from "./pages/Activity";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import Recommendations from "./pages/Recommendations";
import MetaAds from "./pages/MetaAds";
import CreateMetaAd from "./pages/CreateMetaAd";
import EditMetaAd from "./pages/EditMetaAd";
import Trends from "./pages/Trends";
import Notifications from "./pages/Notifications";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./lib/auth";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <div className="data-label">Checking session…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/recommendations" element={<Recommendations />} />
        <Route path="/meta-ads" element={<MetaAds />} />
        <Route path="/meta-ads/create" element={<CreateMetaAd />} />
        <Route path="/meta-ads/edit" element={<EditMetaAd />} />
        <Route path="/trends" element={<Trends />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/rules/new" element={<RuleBuilder />} />
        <Route path="/rules/:id/edit" element={<RuleBuilder />} />
        <Route path="/approvals" element={<Approvals />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}
